import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'sortBy' })

export class SortByPipe implements PipeTransform {

    transform(modules: Array<any>): any {
        if (modules && modules.length) {
            return modules.sort(function (a, b) {
                return parseInt(a.mobile_order) - parseInt(b.mobile_order);
            });
        }
    };
}